import React, { useContext } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { getColor, getLabel, getSortedRiskLevels, initialFinancialRiskFilter } from "./FilterTypes/FinancialRiskFilterType";
import { Button } from "semantic-ui-react";
import { DotLabel } from "components/Dot";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const riskLevels = serverReference.financialRiskLevels.filter(lvl => lvl.value !== "unknown");
const unknownRiskLevel = serverReference.financialRiskLevels.find(lvl => lvl.value === "unknown");

const FinancialRiskFilter = () => {
  const title = RESX.Promoter.FinancialRisk;

  const { register, getValue, setValue } = useContext(FilterContext);
  register("financialRisks", {
    getTitle: () => title,
    renderSelection: (filter) => <div className="flex">
      {getSortedRiskLevels(filter).map((lvl, index) =>
        <React.Fragment key={lvl}>
          {lvl === "unknown" ? getLabel(lvl) : <DotLabel dotColor={getColor(lvl)}>{getLabel(lvl)}</DotLabel>}
          {index !== filter.selectedRiskLevels.length - 1 && <span className="padding-right">,</span>}
        </React.Fragment>
      )}
    </div>,
    hasValue: (filter) => filter.selectedRiskLevels.length > 0,
    reset: () => initialFinancialRiskFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedRiskLevels, b.selectedRiskLevels)
  });

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedRiskLevels, setSelectedRiskLevels] = React.useState(initialFinancialRiskFilter.selectedRiskLevels);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedRiskLevels(getValue("financialRisks").selectedRiskLevels);
    setPopupOpen(true);
  };

  const onRiskLevelToggle = (riskLevel: server.dto.FinancialRiskLevels) => {
    const isSelected = selectedRiskLevels.some(lvl => lvl === riskLevel);
    const newSelection = isSelected
      ? selectedRiskLevels.filter(lvl => lvl !== riskLevel)
      : [...selectedRiskLevels, riskLevel];
    setSelectedRiskLevels(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("financialRisks", { selectedRiskLevels });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={[unknownRiskLevel].map(lvl => lvl.value)}
            selectedItems={selectedRiskLevels}
            onItemToggled={onRiskLevelToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={riskLevels.map(lvl => lvl.value)}
            renderItem={lvl => <DotLabel dotColor={getColor(lvl)}>{getLabel(lvl)}</DotLabel>}
            selectedItems={selectedRiskLevels}
            onItemToggled={onRiskLevelToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default FinancialRiskFilter;